import {
  ASIA,
  ASEAN,
  INDONESIA,
  MEKONG,
  AUSTRALIA,
  CHINA,
  INDIA,
  JAPAN,
  KOREA,
  TAIWAN,
  PACIFIC,
  LIGHT_PREFIX,
  DROPDOWN_PREFIX,
} from './constants';

export const REGIONS_COLOR = {
  [ASIA]: '#2c4d5e',
  [ASEAN]: '#194df1',
  [INDONESIA]: '#194df1',
  [MEKONG]: '#00738d',
  [AUSTRALIA]: '#f4cf20',
  [CHINA]: '#00a8f0',
  [INDIA]: '#ff8f41',
  [JAPAN]: '#4db19d',
  [KOREA]: '#fd5d4b',
  [TAIWAN]: '#996cb7',
  [PACIFIC]: '#00A651',
  [`${LIGHT_PREFIX}${ASIA}`]: '#dfe4e7',
  [`${LIGHT_PREFIX}${ASEAN}`]: '#dde4fd',
  [`${LIGHT_PREFIX}${INDONESIA}`]: '#dde4fd',
  [`${LIGHT_PREFIX}${MEKONG}`]: '#dde4fd',
  [`${LIGHT_PREFIX}${AUSTRALIA}`]: '#fdf8de',
  [`${LIGHT_PREFIX}${CHINA}`]: '#d9f2fd',
  [`${LIGHT_PREFIX}${INDIA}`]: '#ffeee3',
  [`${LIGHT_PREFIX}${JAPAN}`]: '#e4f3f0',
  [`${LIGHT_PREFIX}${KOREA}`]: '#ffe7e4',
  [`${LIGHT_PREFIX}${TAIWAN}`]: '#f0e9f4',
  [`${LIGHT_PREFIX}${PACIFIC}`]: '#17e269',
  [`${DROPDOWN_PREFIX}${ASIA}`]: '#96a6af',
  [`${DROPDOWN_PREFIX}${ASEAN}`]: '#8ca6f8',
  [`${DROPDOWN_PREFIX}${INDONESIA}`]: '#8ca6f8',
  [`${DROPDOWN_PREFIX}${MEKONG}`]: '#dde4fd',
  [`${DROPDOWN_PREFIX}${AUSTRALIA}`]: '#fae790',
  [`${DROPDOWN_PREFIX}${CHINA}`]: '#80d4f8',
  [`${DROPDOWN_PREFIX}${INDIA}`]: '#ffc7a0',
  [`${DROPDOWN_PREFIX}${JAPAN}`]: '#a6d8ce',
  [`${DROPDOWN_PREFIX}${KOREA}`]: '#feaea5',
  [`${DROPDOWN_PREFIX}${TAIWAN}`]: '#ccb6db',
  [`${DROPDOWN_PREFIX}${PACIFIC}`]: '#88edb5',
};

export const COLORS = {
  WHITE: '#fff',
  LIGHT_GRAY: '#c8cfd2',
  GRAY: '#a1a1a1',
  GULL_GRAY: '#96a6af',
  DUSTY_GRAY: '#979797',
  SILVER: '#c9c9c9',
  DARK_BLUE: '#334D5B',
  MAKO: '#3e4149',
  DARK_GRAY: '#4a4a4a',
  SHARK: '#212529',
  ALTO: '#d3d3d3',
  SILVER_CHALICE: '#aaaaaa',
};

export const MAP_COLORS = {
  NO_DATA: '#dddddd',
  STROKE: '#333',
  INACTIVE_STROKE: 'rgba(0,0,0, .4)',
  INACTIVE_FILL: 'rgba(238, 238, 238, 0.4)',
  LOW_VALUE: '#ffffff',
};

export const SUMMARY_BAR_COLORS = {
  BORDER: '#ddd',
  BUTTON_LABEL: '#b3b3b',
  BUTTON_VALUE: '#c4d5e',
  CLEAR_BUTTON: '#2c4d5e',
  CLEAR_LIGHT: '#767676',
  CLEAR_DARK: '#212121',
};
